import ApiService from '@/services/apiService';
import { mapMutations, mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'ViewDigitalTwinDigitalTwinOverview',
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      favouriteFilter: false,
      createTwinWithTemplate: false,
      twinCreateDialog: false,
      showExportDialog: false,
      twinCreateFormValid: false,
      isCreatingTwin: false,
      createDialogButtons: [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.saveAndCreate'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }],
      createTwinObject: {
        properties: {},
        data: {}
      },
      selected: null,
      favType: 'digitalTwin',
      favId: null,
      treeLoading: false,
      search: '',
      open: [],
      counter: 0,
      buttons01: [{
        title: this.$i18n_t('Common.addNew'),
        icon: 'fal fa-plus',
        valid: true
      }],
      initialActiveDtwinId: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    hasManageAllPermission() {
      return this.permissions['all.manage'];
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    headerBG() {
      return './img/board-30.png';
    },
    requiredRule() {
      return v => !!v && v.trim() !== '' || this.$i18n_t('Common.fieldRequired');
    }
  },
  watch: {
    selected() {
      if (this.selected) {
        if (`${this.$route.query.active}` !== `${this.selected.id}`) {
          this.initialActiveDtwinId = this.selected.id;
          this.$route.query.active = this.selected.id;
        }
      }
      this.$route.query.search = this.search;
    },
    '$route.query.active': {
      handler() {
        this.initialActiveDtwinId = this.$route.query.active ? parseInt(this.$route.query.active) : null;
      }
    },
    search() {
      this.didSelectTwin(this.selected);
    }
  },
  created() {
    this.$store.state.app.loading = false;
    this.initialActiveDtwinId = this.$route.query.active ? parseInt(this.$route.query.active) : null;
    this.search = this.$route.query.search ? this.$route.query.search : '';
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    get,
    createTwin(selected) {
      this.createTwinObject = {
        properties: {},
        data: {},
        tenantId: selected.tenantId,
        parentId: selected.id,
        reuseParentScope: true // set to true by MWa 16.12.2024 - due to unused scope deletion decided that way
        // reuseParentScope: false, // reset to false by MWa 22.12.2021 - PM wanted it that way
        // I have explained why we set it to true - we want to do it again in 2022 after
        // informing customers about changed way to create twins
      };
      this.twinCreateDialog = true;
    },
    saveAndCreateTwin() {
      this.isCreatingTwin = true;
      return ApiService.digitalTwinCreate(this, this.createTwinObject).then(result => {
        this.isCreatingTwin = false;
        this.twinCreateDialog = false;
        this.$snack(this.$i18n_t('Common.digitalTwins.twinCreated'), 'success');
        this.pushToRouter(`/digitaltwin-mgmt/${result.id}`);
        this.$store.state.app.dtwins = {};
        this.selected = null;
        this.initialActiveDtwinId = null;
        if (this.$refs['twin-tree']) {
          this.$refs['twin-tree'].activeDtwinId = null;
          this.$refs['twin-tree'].initTree();
        }
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.digitalTwins.twinCreatedFail'), 'error');
        }
      }).finally(() => {
        this.isCreatingTwin = false;
        this.$store.state.app.loading = false;
      });
    },
    deleteTwin(selected) {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.$store.state.app.dtwins = {};
      ApiService.digitalTwinDelete(selected.id).then(() => {
        this.$snack(this.$i18n_t('Common.digitalTwins.twinDeleted'), 'success');
        this.$store.state.app.dtwins = {};
        this.selectedDigitalTwin(selected);
        if (this.$refs['twin-tree']) {
          this.$refs['twin-tree'].activeDtwinId = null;
          this.$refs['twin-tree'].initTree();
        }
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.digitalTwins.twinDeletedFail'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    loadedInitialDtwins(dtwins) {
      if (dtwins && dtwins.length > 0) {
        this.didSelectTwin(this.selected || dtwins[0]);
      }
    },
    didSelectTwin(e) {
      if (e && e.id) {
        this.selected = e;
        let url = window.location.href;
        window.location.href = url.split('?')[0];
        window.location.href += `?active=${e.id}`;
        if (this.search) {
          window.location.href += `&search=${this.search}`;
        }
      }
    },
    highlightTwinName(twinName) {
      if (this.search) {
        return twinName.replace(new RegExp(`(${this.search})`, 'gi'), '<span style="font-weight: bold">$1</span>');
      }
      return twinName;
    },
    pushToRouter(path, selected = null) {
      this.$router.push({
        path: path,
        query: {
          parent: selected ? selected.id : null
        }
      });
    },
    selectedDigitalTwin(item) {
      this.initialActiveDtwinId = item.parentId;
      this.$router.replace({
        path: '/digitaltwin-mgmt',
        query: {
          active: item.parentId
        }
      });
      this.selected = item;
      this.open = this.$refs['twin-tree'].open;
      this.counter++;
    }
  }
};